/**
 * useContextMenu.ts
 * 右クリックコンテキストメニューの状態を管理するカスタムフック
 * ノードやエッジの削除メニュー表示に使用
 */
import { useState, useCallback } from 'react';

/**
 * コンテキストメニューの状態型
 * null の場合はメニュー非表示
 */
export type ContextMenuState = {
  x: number;           // 表示位置X座標
  y: number;           // 表示位置Y座標
  type: 'edge' | 'node';  // 対象の種類
  id: string;          // 対象のID
} | null;

/**
 * コンテキストメニュー管理フック
 *
 * @returns {Object} コンテキストメニュー管理オブジェクト
 * @returns contextMenu - 現在のメニュー状態（nullなら非表示）
 * @returns showContextMenu - メニューを表示する関数
 * @returns hideContextMenu - メニューを非表示にする関数
 */
export function useContextMenu() {
  const [contextMenu, setContextMenu] = useState<ContextMenuState>(null);

  /** コンテキストメニューを表示 */
  const showContextMenu = useCallback((state: NonNullable<ContextMenuState>) => {
    setContextMenu(state);
  }, []);

  /** コンテキストメニューを非表示 */
  const hideContextMenu = useCallback(() => {
    setContextMenu(null);
  }, []);

  return { contextMenu, showContextMenu, hideContextMenu };
}

